import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Badge, Row, Col, Switch } from 'antd';
import Translate from 'react-translate-component';

import { sort } from 'ramda';

import { TASK_PRIORITIES } from 'constants/calendar';
import { notEmpty } from 'utils/ramdaAdditions';

import { DateRangeField } from 'components/common/fields/DateTimeFields';
import { openModalTaskUpdate } from 'actions/modalActions';
import CustomIcon from 'components/common/CustomIcon';

const sortByDateFrom = (item1, item2) => parseInt(item1.dateFrom, 10) < parseInt(item2.dateFrom, 10) ? -1 : 1;
const sortByDate = sort(sortByDateFrom);

const LinkToUpdate = ({ children, update }) => <a onClick={update}>{children}</a>;
const Span = ({ children }) => <span>{children}</span>;

@connect(null, { openModalTaskUpdate })
export default class TaskList extends Component {
    state = {
        menuVisible: false
    };

    isShowTask = (task) => {
        const { showCompletedTasks } = this.props;
        return showCompletedTasks || !task.done;
    };

    renderTasks = () => {
        const { tasks, openModalTaskUpdate, isAllowedToEdit } = this.props;
        const filteredTasks = tasks.filter(this.isShowTask);
        const sorted = sortByDate(filteredTasks);
        const DescWrap = isAllowedToEdit ? LinkToUpdate : Span;

        return notEmpty(sorted) ? (
            <div>
                <Row className="task-header calendar-task-box__row">
                    <Col className="task-number" />
                    <Col className="task-date"><Translate content="calendar.task_list_headers.date" /></Col>
                    <Col className="task-desc"><Translate content="calendar.task_list_headers.description" /></Col>
                    <Col className="task-priority"><Translate content="calendar.task_list_headers.priority" /></Col>
                    <Col className="task-done"><Translate content="calendar.task_list_headers.done" /></Col>
                </Row>
                {filteredTasks.map((task, index) => (
                    <Row className="calendar-task-box__row" key={task.id}>
                        <Col className="task-number">{index + 1}</Col>
                        <Col className="task-date">
                            <DateRangeField date={{ from: task.dateFrom, to: task.dateTo }} />
                        </Col>
                        <Col className="task-desc">
                            <DescWrap update={() => openModalTaskUpdate(task)}>{task.description}</DescWrap>
                        </Col>
                        <Col className="task-priority">
                            {!!task.priority && (
                                <Badge
                                    count={task.priority}
                                    className={TASK_PRIORITIES[task.priority]}
                                />
                            )}
                        </Col>
                        <Col className="task-done">
                            {task.done && <CustomIcon type="check" />}
                        </Col>
                    </Row>)
                )}
            </div>
        ) : (
            <Row className="calendar-row calendar-row_no-data">
                <Translate content="calendar.no_tasks" />
            </Row>
        );
    };

    render() {
        const { showCompletedTasks, onShowCompletedTasksToggle } = this.props;

        return (
            <div className="calendar-task-box">
                <div className="task-title">
                    <Translate content="calendar.tasks" />
                    <div className="menu-show-toggle">
                        <Translate content="calendar.show_completed_tasks" className="label" />
                        <Switch checked={showCompletedTasks} onChange={onShowCompletedTasksToggle} />
                    </div>
                </div>
                {this.renderTasks()}
            </div>
        );
    }
}
